import React from "react";
// import PropTypes from "prop-types";
import "./Services.scss";
import desktopIcon from "../../assets/images/project-icons/services-icons/design-icon.png";
import designIcon from "../../assets/images/project-icons/services-icons/design-icon.png";
import mobileIcon from "../../assets/images/project-icons/services-icons/mobile-icon.png";
import webIcon  from "../../assets/images/project-icons/services-icons/web-icon.png";

const Services = () => {
    return (
        <div className="services-container text-center">
            <div className="services-sub-container d-flex flex-column justify-content-center align-items-center">

                <div className=" services-header-container">
                    <h1 className="services-header">I Can Do...</h1>
                </div>

                <div className="w-100 pt-1 mt-5 h-auto row">
                    <div className="col-md-6 col-sm-12 p-0 d-flex flex-column text-dark services-header text-center ">
                        <div className="do-header">SOFTWARE DEVELOPMENT</div>
                        <div className="d-flex flex-row justify-content-center">
                            <div className="icon-container hvr-pulse text-center">
                                <img alt={""} src={desktopIcon} className="icon-background align-self-center"/>
                                <i className="fa fa-flask fa-2x"></i>
                            </div>
                            <p className="service-desc">I can develop software solutions to your needs. Management
                                systems and Standalone Systems can be implemented for your own business.</p>
                        </div>

                    </div>
                    <div className="col-md-6 col-sm-12 text-dark p-0 d-flex flex-column  services-header text-center">
                        <h3 className="do-header">WEB DEVELOPMENT</h3>
                        <div className="d-flex flex-row">
                            <div className="icon-container hvr-pulse text-center">
                                <img alt={""} src={webIcon} className="icon-background"/>
                            </div>
                            <p className="service-desc">Highly responsive and eye-catching websites for your needs with
                                a negotiable price.</p>
                        </div>


                    </div>
                    <div className="col-md-6 col-sm-12 d-flex flex-column text-dark services-header text-center p-0">
                        <h3 className="do-header">MOBILE APPLICATION DEVELOPMENT</h3>
                        <div className="d-flex flex-row">
                            <div className="icon-container hvr-pulse  text-center">
                                <img alt={""} src={mobileIcon} className="icon-background"/>
                            </div>
                            <p className="service-desc">Highly creative and responsive mobile applications can be
                                designed and implemented for your needs.</p>
                        </div>

                    </div>
                    <div className="col-md-6 col-sm-12 d-flex flex-column text-dark services-header text-center  p-0">
                        <h3 className="do-header">UI DESIGNING & ADVERTISING</h3>
                        <div className="d-flex flex-row">
                            <div className="icon-container text-center hvr-pulse">
                                <img alt={""} src={designIcon} className="icon-background"/>
                            </div>
                            <p className="service-desc">I can design user interfaces to advertise your brands and I can
                                implement new and fresh designs as your wish.</p>
                        </div>


                    </div>


                </div>
            </div>
        </div>
    );
}

export default Services;
